import { c as _c } from "react/compiler-runtime";
import "../styles/globals.css";
import { setBreadcrumbs } from "@navikt/nav-dekoratoren-moduler";
import { configureLogger } from "@navikt/next-logger";
import { type DehydratedState, HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { AppProps } from "next/app";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { createBreadcrumbs } from "@/breadcrumbs/breadcrumbs";
import { ErrorBoundary } from "@/components/error/ErrorBoundary";
import { TestScenarioSelector } from "@/components/testscenarioselector/TestScenarioSelector";
import { initFaro } from "@/faro/initFaro";
import { minutesToMillis } from "@/utils/dateUtils";
import { getTestScenario, setTestScenario } from "@/utils/testScenarioUtils";
configureLogger({
  basePath: "/syk/aktivitetskrav"
});
function MyApp(t0) {
  const $ = _c(16);
  const {
    Component,
    pageProps
  } = t0;
  const {
    pathname
  } = useRouter();
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  let t2;
  let t3;
  if ($[1] !== pathname) {
    t2 = () => {
      setBreadcrumbs(createBreadcrumbs(pathname));
    };
    t3 = [pathname];
    $[1] = pathname;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const TestScenarioDevTools = _temp3;
  let t4;
  if ($[4] !== Component || $[5] !== pageProps) {
    t4 = <Component {...pageProps} />;
    $[4] = Component;
    $[5] = pageProps;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== pageProps.dehydratedState || $[8] !== t4) {
    t5 = <HydrationBoundary state={pageProps.dehydratedState}>{t4}</HydrationBoundary>;
    $[7] = pageProps.dehydratedState;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TestScenarioDevTools />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <main tabIndex={-1} id="maincontent">{t5}{t6}</main>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== queryClient || $[14] !== t7) {
    t8 = <ErrorBoundary><QueryClientProvider client={queryClient}>{t7}</QueryClientProvider></ErrorBoundary>;
    $[13] = queryClient;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp3() {
  if (process.env.NEXT_PUBLIC_RUNTIME_ENVIRONMENT === "local" || process.env.NEXT_PUBLIC_RUNTIME_ENVIRONMENT === "demo") {
    const hasActiveScenario = !!getTestScenario();
    if (!hasActiveScenario) {
      setTestScenario("FORHANDSVARSEL");
    }
    return <TestScenarioSelector />;
  }
  return null;
}
function _temp2() {
  initFaro();
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: minutesToMillis(30)
      }
    }
  });
}
export default MyApp;